<template>
    <div>
        <div class="actions__container">
            <div>
                <a
                    href="#"
                    class="btn btn-primary w-40 inline-block mr-1 mb-2"
                    @click.prevent="$router.push({ name: 'customerCreate' })"
                >
                    Создать
                </a>
            </div>
        </div>

        <ContentSearch />

        <ContentTable
            :inverse-toggle-icons="true"
            :table-actions="tableActions"
            :headers="tableHeaders"
            :table-rows="tableData"
            :meta="pagination"
            :loading="loading"
            @edit="editAction"
            @delete="deleteAction"
        />

        <PopupDeleteModal
            :is-open="modalOpen"
            :entity-name="modalTitle"
            :modal-data="modalData"
            @update:isOpen="modalOpen = $event"
            @deleteModalAccepted="onDeleteModalAccepted"
        />
    </div>
</template>

<script>
import ContentTable from '@/components/tables/ContentTable';
import PopupDeleteModal from '@/components/modals/PopupDeleteModal';
import ContentSearch from '@/components/base/ContentSearch';
import { errorResponse } from '@/mixins/form/form-mixin';
import { pageMixin } from '@/mixins/pageMixin';

export default {
    components: { ContentSearch, PopupDeleteModal, ContentTable },
    mixins: [errorResponse, pageMixin],
    async beforeRouteUpdate(to, from, next) {
        await this.fetchCustomers({ ...to.query });
        next();
    },
    data() {
        return {
            loading: false,
            modalOpen: false,
            modalTitle: null,
            modalData: null,
            tableActions: [
                { name: 'edit', title: 'редактировать', icon: 'Edit2Icon', cbName: 'edit' },
                { name: 'delete', title: 'удалить', class: 'bg-red-400', icon: 'TrashIcon', cbName: 'delete' },
            ],
            tableHeaders: [
                { field: 'id', label: '#' },
                { field: 'phone', label: 'Телефон' },
                { field: 'first_name', label: 'Имя' },
                { field: 'last_name', label: 'Фамилия' },
                { field: 'email', label: 'E-mail' },
            ],
            tableData: [],
            pagination: null,
        };
    },
    async created() {
        this.$store.commit('main/setPageHeader', 'Покупатели');
        await this.fetchCustomers(this.$route.query);
    },
    methods: {
        async fetchCustomers(params) {
            try {
                this.loading = true;
                const { data } = await this.axios.get('/customers', { params });
                this.tableData = data.data;
                this.pagination = data.meta;
                this.loading = false;
            } catch (ex) {
                this.loading = false;
                console.log('cant fetch customers: ' + ex);
            }
        },
        editAction(row) {
            // this.$router.push({ name: 'customerEdit', params: { id: row.id } });
            this._pMTransitionToEditPageWithQuery('customerEdit', { id: row.id });
        },
        deleteAction(row) {
            this.modalData = row;
            this.modalOpen = true;
        },
        onDeleteModalAccepted(data) {
            this.axios
                .delete('/customers/' + data.id)
                .then(() => {
                    this.fetchCustomers(this.$route.query);
                    this.modalOpen = false;
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });
        },
    },
};
</script>

<style></style>
